import { TypographyV3, type TypographyV3Props } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

interface HeadingProps extends Omit<TypographyV3Props, 'children'> {
  readonly tx: MessageKey;
}

const Heading = ({ tx, ...props }: HeadingProps): JSX.Element => {
  const t = useTranslations();
  return (
    <TypographyV3 Element="h2" variant="h2" className="mb-8 mt-20" {...props}>
      {t(tx)}
    </TypographyV3>
  );
};

export default Heading;
